import { betHistoryServiceV2 } from '../../domain/betHistory/index'
import { Ga4EventType, ga4Info } from '../../util/GA4/index'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { ButtonProps } from '../menu/interface/ButtonProps'
import { Button } from '../../UI/Button'
import { useBetHistoryStore } from '../../domain/betHistory/store/betHistoryStore'

export const BetHistoryButtonV2 = (props: ButtonProps) => {
  return (
    <Button
      name="Bet History Button"
      defaultView="history_normal_v2"
      hoverView="history_hover_v2"
      pressedView="history_click_v2"
      disabledView="history_disabled_2"
      enabled={!props.disabled}
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      onPressing={() => {
        soundManager.play(SoundType.buttonConfirm)
      }}
      onPress={() => {
        betHistoryServiceV2.getBetList()
        useBetHistoryStore.setState({
          isOpened: true,
        })
        ga4Info.addEvent(Ga4EventType.menu_history)
      }}
    />
  )
}
